export default __webpack_public_path__ + "static/media/third-party-data-consent-en-0.ba9ed011.jpg";